export const state = {
  connected: false,
  offline: false
}

export const getters = {
  connectedState: state => state.connected,
  offlineState: state => state.offline
}

export const mutations = {
  connectedCommit (state, connected) {
    state.connected = connected
  },
  offlineCommit (state, offline) {
    state.offline = offline
  }
}

export const actions = {
  async connectedAction ({ commit }, connected) {
    commit('connectedCommit', connected)
  },
  async offlineAction ({ commit }, offline) {
    commit('offlineCommit', offline)
  }
}
